module.exports = __webpack_public_path__ + "static/media/1POLICY5.d5c27c84.jpg";